import { render, staticRenderFns } from "./GraphqlTableView.vue?vue&type=template&id=6bd4e293"
import script from "./GraphqlTableView.vue?vue&type=script&lang=js"
export * from "./GraphqlTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports